import {
  type DeleteApiGreetingsIdPathParams,
  type PostApiGreetingsMutationRequest,
  type PutApiGreetingsIdMutationRequest,
  type PutApiGreetingsIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  greetingByIdQuery,
  greetingCreate,
  greetingDelete,
  greetingUpdate,
  greetingsStatus,
} from '../api'

// By Id
interface GreetingGateProps {
  id: string
}
export const GreetingGate = createGate<GreetingGateProps>()

sample({
  clock: GreetingGate.open,
  fn: ({ id }: GreetingGateProps) => ({ id }),
  target: greetingByIdQuery.start,
})

sample({
  clock: GreetingGate.close,
  target: greetingByIdQuery.reset,
})

// Create

export const greetingSubmitted = createEvent<PostApiGreetingsMutationRequest>()
sample({
  clock: greetingSubmitted,
  fn: (data) => ({ data }),
  target: [greetingCreate.start],
})

sample({
  clock: greetingCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

export const greetingEdited = createEvent<{
  id: PutApiGreetingsIdPathParams['Id']
  data: PutApiGreetingsIdMutationRequest
}>()
sample({
  clock: greetingEdited,
  fn: ({ id, data }) => ({ id, data }),
  target: [greetingUpdate.start],
})

sample({
  clock: greetingUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})
// Delete

export const greetingDeleted = createEvent<{
  id: DeleteApiGreetingsIdPathParams['Id']
}>()

sample({
  clock: greetingDeleted,
  fn: ({ id }) => ({ id }),
  target: [greetingDelete.start],
})

sample({
  clock: greetingDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})

sample({
  clock: greetingsStatus.finished.success,
  fn: () => {
    return {
      message: 'Состояние приветственных экранов обновлено',
    }
  },
  target: showNotificationSuccessFx,
})
